var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("create-tab-modal", {
        ref: "createTabModal",
        attrs: {
          selectedGuests: _vm.newTabGuests,
          createTab: _vm.createNewTab,
          createGuest: _vm.createGuest,
          guests: _vm.taggedGuests,
        },
      }),
      _vm._v(" "),
      _c("add-to-tab-modal", {
        ref: "addToTabModal",
        attrs: { tabs: _vm.tabs, addToTab: _vm.mergeIntoTab },
      }),
      _vm._v(" "),
      _c("collect-payment-modal", {
        ref: "paymentModal",
        attrs: {
          allowPartial: !!_vm.tab.id,
          payer: _vm.selectedGuest,
          tab: _vm.tab,
          loading: _vm.isRequestingPayment,
        },
        on: {
          "submit-payment": _vm.initiateCharge,
          "submit-adjustment": _vm.updateCurrentTab,
        },
      }),
      _vm._v(" "),
      _c("terminal-status-modal"),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: _vm.cardReaderTitle,
            "modal-class": "terminal-modal",
            "hide-footer": "",
            centered: "",
            size: "sm",
          },
          on: {
            hidden: function ($event) {
              _vm.cardReaderInput = ""
            },
          },
          model: {
            value: _vm.cardReaderIsRequesting,
            callback: function ($$v) {
              _vm.cardReaderIsRequesting = $$v
            },
            expression: "cardReaderIsRequesting",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.cardReaderMessage) + "\n    "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.cardReaderInput,
                expression: "cardReaderInput",
              },
            ],
            ref: "cardInput",
            staticClass: "hidden-card-input",
            domProps: { value: _vm.cardReaderInput },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.cardReaderInput = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          !_vm.validCardDetails
            ? _c("div", { staticClass: "focused-indicator" }, [
                _c("b", [_vm._v("Ready to swipe")]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "swipe-image",
                  attrs: { src: require("@/assets/gifs/swipegif1.gif") },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.validCardDetails
            ? _c(
                "div",
                { staticClass: "not-focused-indicator" },
                [
                  _c("span", [_vm._v("Reader Disengaged.")]),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.selectCardInput },
                    },
                    [_vm._v("Engage Reader")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("section", { staticClass: "card-details" }, [
            _c("br"),
            _c("b", [_vm._v("Card Number:")]),
            _vm._v(" "),
            _c("span", { staticClass: "card-values" }, [
              _vm._v(_vm._s(_vm.cardReaderNumber)),
            ]),
            _vm._v(" "),
            _c("br"),
            _c("b", [_vm._v("Exp Month:")]),
            _vm._v(" "),
            _c("span", { staticClass: "card-values" }, [
              _vm._v(_vm._s(_vm.cardReaderMonth)),
            ]),
            _vm._v(" "),
            _c("br"),
            _c("b", [_vm._v("Exp Year:")]),
            _vm._v(" "),
            _c("span", { staticClass: "card-values" }, [
              _vm._v(_vm._s(_vm.cardReaderYear)),
            ]),
          ]),
          _vm._v(" "),
          _vm.cardReaderPaymentInProcess
            ? _c(
                "section",
                [
                  _c("spinner-loader", {
                    attrs: { loading: _vm.cardReaderPaymentInProcess },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.validCardDetails
            ? _c(
                "div",
                { staticClass: "mb-2" },
                [
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        variant: "danger",
                        disabled: _vm.cardReaderPaymentInProcess,
                      },
                      on: { click: _vm.selectCardInput },
                    },
                    [_vm._v("\n        Reset\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      attrs: {
                        variant: "success",
                        disabled: _vm.cardReaderPaymentInProcess,
                      },
                      on: { click: _vm.cardReaderCharge },
                    },
                    [_vm._v("\n        Charge\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.devMode
            ? _c(
                "b-btn",
                {
                  attrs: {
                    variant: "info",
                    disabled: _vm.cardReaderPaymentInProcess,
                  },
                  on: { click: _vm.testCard },
                },
                [_vm._v("\n      Test Card\n    ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRequestingItems
        ? _c(
            "section",
            { staticClass: "content-container" },
            [_c("spinner-loader", { attrs: { loading: true } })],
            1
          )
        : _vm.showNoInventory
        ? _c("section", { staticClass: "content-container" }, [
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("b-btn", { on: { click: _vm.goToInventory } }, [
                  _vm._v("Create your inventory here"),
                ]),
              ],
              1
            ),
          ])
        : _c("section", { staticClass: "display-content content-container" }, [
            !_vm.selectedTab.id && _vm.allowWalkin === false
              ? _c("div", { staticClass: "tab-selection-screen" }, [
                  _c(
                    "div",
                    { staticClass: "main-pos-display full-length" },
                    [
                      _c("item-display", {
                        attrs: {
                          selectItem: _vm.loadTab,
                          items: _vm.tabs,
                          filterIds: _vm.activeTabFilter,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.tabsLoading
                    ? _c(
                        "div",
                        { staticClass: "tabs-loading" },
                        [
                          _c("spinner-loader", {
                            attrs: { loading: _vm.tabsLoading },
                          }),
                        ],
                        1
                      )
                    : _c("div", { staticClass: "left-pos-display" }, [
                        _c("div", { staticClass: "start-buttons" }, [
                          _c("h4", { staticClass: "center" }, [
                            _vm._v(_vm._s(_vm.$t("pos_subtitle"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "button-group" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "btn-lg long-button",
                                  attrs: { variant: "secondary" },
                                  on: { click: _vm.onClickQuickSale },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("pos_quick_sale")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.addToTabModal",
                                      modifiers: { addToTabModal: true },
                                    },
                                  ],
                                  staticClass: "btn-lg long-button",
                                  attrs: { variant: "secondary" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("pos_hotel_guests")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName: "v-b-modal.createTabModal",
                                      modifiers: { createTabModal: true },
                                    },
                                  ],
                                  staticClass: "btn-lg long-button",
                                  attrs: { variant: "secondary" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("pos_all_contacts")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                ])
              : _c("div", { staticClass: "active-pos" }, [
                  _c(
                    "div",
                    { staticClass: "main-pos-display" },
                    [
                      _c("item-display", {
                        attrs: {
                          selectItem: _vm.addItem,
                          items: _vm.items,
                          filterIds: _vm.itemTagFilter,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "category-display" }, [
                    null === _vm.selectedMenu
                      ? _c(
                          "div",
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _vm._l(_vm.filteredMenus, function (menu) {
                              return _c(
                                "b-button",
                                {
                                  key: menu.id,
                                  staticStyle: { margin: "8px" },
                                  attrs: { size: "lg" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.selectMenu(menu)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(menu.name) +
                                      "\n          "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "menu-category-header" },
                              [
                                _c(
                                  "b-button-group",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "dark" },
                                        on: { click: _vm.clearMenu },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fi fi-arrow-left",
                                        }),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "secondary" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.selectMenu(
                                              _vm.selectedMenu
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.selectedMenu.name) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    null != _vm.selectedCategory
                                      ? _c(
                                          "b-button",
                                          { attrs: { variant: "dark" } },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.selectedCategory.name
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(
                              _vm.selectedMenu.menu_tag,
                              function (category) {
                                return _c(
                                  "b-button",
                                  {
                                    key: category.id,
                                    staticStyle: { margin: "8px" },
                                    attrs: { size: "lg" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectCategory(category)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(category.name) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              }
                            ),
                          ],
                          2
                        ),
                  ]),
                  _vm._v(" "),
                  _vm.tabsLoading
                    ? _c(
                        "div",
                        { staticClass: "tabs-loading" },
                        [
                          _c("spinner-loader", {
                            attrs: { loading: _vm.tabsLoading },
                          }),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        { staticClass: "left-pos-display" },
                        [
                          _vm.disabledLoading
                            ? _c(
                                "div",
                                { staticClass: "tabs-loading" },
                                [
                                  _c("spinner-loader", {
                                    attrs: { loading: _vm.disabledLoading },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "return-button",
                              on: { click: _vm.freshTab },
                            },
                            [_c("i", { staticClass: "fi fi-arrow-left" })]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "tab-name" }, [
                            _vm._v(_vm._s(_vm.selectedGuest)),
                          ]),
                          _vm._v(" "),
                          _c("guest-tab", {
                            ref: "guestTab",
                            class:
                              _vm.tab.tab_item.length > 0 && !_vm.tab.id
                                ? "quick-sale"
                                : "add-item",
                            attrs: {
                              tab: _vm.tab,
                              showTax: true,
                              removeCharge: _vm.removeItem,
                              showDescription: false,
                              alwaysShowTips: "",
                            },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tab-buttons" }, [
                            _c(
                              "div",
                              { staticClass: "button-group" },
                              [
                                _vm.selectedTab.tab_item.length > 0
                                  ? _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName:
                                                      "v-b-modal.addToTabModal",
                                                    modifiers: {
                                                      addToTabModal: true,
                                                    },
                                                  },
                                                ],
                                                class: [
                                                  "large-command-btn",
                                                  {
                                                    hidden:
                                                      !!_vm.selectedTab.id,
                                                  },
                                                ],
                                                attrs: {
                                                  ariant: "primary",
                                                  disabled:
                                                    _vm.selectedTab.tab_item
                                                      .length === 0,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t("pos_add_tab")
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName:
                                                      "v-b-modal.createTabModal",
                                                    modifiers: {
                                                      createTabModal: true,
                                                    },
                                                  },
                                                ],
                                                class: {
                                                  hidden: !!_vm.selectedTab.id,
                                                  "large-command-btn": true,
                                                },
                                                attrs: {
                                                  variant: "outline-primary",
                                                  disabled:
                                                    _vm.selectedTab.tab_item
                                                      .length === 0,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.$t("pos_start_tab")
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.selectedTab.id &&
                                _vm.selectedTab.stats.balance_due <= 0 &&
                                _vm.selectedTab.stats.payments_made > 0
                                  ? _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          [
                                            _c(
                                              "b-btn",
                                              {
                                                staticClass:
                                                  "medium-command-btn",
                                                attrs: {
                                                  variant: "outline-success",
                                                  disabled: _vm.disabledLoading,
                                                },
                                                on: {
                                                  click: _vm.closeCurrentTab,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Close Tab\n                "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "b-row",
                                      [
                                        _vm.selectedTab.tab_item.length > 0
                                          ? _c(
                                              "b-col",
                                              [
                                                _c(
                                                  "b-btn",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "b-modal",
                                                        rawName:
                                                          "v-b-modal.collectPaymentModal",
                                                        modifiers: {
                                                          collectPaymentModal: true,
                                                        },
                                                      },
                                                    ],
                                                    staticClass:
                                                      "medium-command-btn mt-2",
                                                    attrs: { variant: "dark" },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "pos_settle_payment"
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n      You don't have any items in your inventory yet."),
      _c("br"),
      _vm._v('\n      Create your first one by clicking "New Item."\n    '),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu-category-header" }, [
      _c("span", { staticStyle: { margin: "12px", "font-size": "20pt" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }